export default __webpack_public_path__ + "static/media/offline.cb42eb23.svg";